module.exports = __webpack_public_path__ + "img/Tessellate59.87da3b0b.jpg";